import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        
        <main className="pt-24 pb-16">
          <div className="max-w-4xl mx-auto px-6">
            <h1 className="text-4xl md:text-5xl font-display font-bold text-navy-900 mb-8">
              Privacy Policy
            </h1>

            <div className="prose prose-lg max-w-none">
              <p className="text-navy-600 mb-6">
                <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">1. Information We Collect</h2>
                <p className="text-navy-600 mb-4">
                  We collect information you provide directly to us, including:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>Name and contact information (email, phone number)</li>
                  <li>Business information (company name, website URL)</li>
                  <li>Communication preferences</li>
                  <li>Information submitted through forms on our website</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">2. How We Use Your Information</h2>
                <p className="text-navy-600 mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Send you technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Send you marketing communications (with your consent)</li>
                  <li>Monitor and analyze trends and usage</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">3. Information Sharing</h2>
                <p className="text-navy-600 mb-4">
                  We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>With your consent</li>
                  <li>To comply with legal obligations</li>
                  <li>To protect our rights and safety</li>
                  <li>With service providers who assist in our operations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">4. Data Security</h2>
                <p className="text-navy-600">
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">5. Cookies and Tracking</h2>
                <p className="text-navy-600 mb-4">
                  We use cookies and similar tracking technologies to collect information about your browsing activities. You can control cookies through your browser settings.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">6. Your Rights</h2>
                <p className="text-navy-600 mb-4">
                  You have the right to:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Opt-out of marketing communications</li>
                  <li>Object to processing of your information</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">7. Third-Party Links</h2>
                <p className="text-navy-600">
                  Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">8. Children's Privacy</h2>
                <p className="text-navy-600">
                  Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">9. Changes to This Policy</h2>
                <p className="text-navy-600">
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">10. Contact Us</h2>
                <p className="text-navy-600 mb-4">
                  If you have questions about this Privacy Policy, please contact us at:
                </p>
                <div className="bg-navy-50 p-6 rounded-lg">
                  <p className="text-navy-600">
                    <strong>Florida AI Marketing Experts</strong><br />
                    Email: privacy@floridaaimarketingexperts.com<br />
                    Phone: (305) 555-0123
                  </p>
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </Suspense>
  );
}
